<template>
  <div>
    <div v-show="isForeign">
      <div id="embed-target"></div>
    </div>

    <div class="confrim-order" v-show="!isForeign">
      <section class="container mar-t-60" v-if="goodsData.emsStoreInfoList.length">
        <div class="container-title">收货地址 Receiving address</div>
        <SelectAddress :addressList="addressList" :address="address" @postAddress="getAddress"/>
      </section>
      <section class="container mar-t-60">
        <template v-for="emsStore in goodsData.emsStoreInfoList">
          <OrderItem :info="emsStore" :takeType="1" :key="emsStore.entityId"/>
        </template>
        <template v-for="takeStore in goodsData.takeStoreInfoList">
          <OrderItem :info="takeStore" :takeType="2" :key="takeStore.entityId"/>
        </template>
      </section>
      <section class="container mar-t-60 mar-b-60" v-if="couponList.length">
        <div class="container-title">优惠券 Coupons</div>
        <SelectCoupons :couponList="couponList" :qrCode.sync="qrCode" @postQrcode="getQrcode"/>
      </section>
      <section class="container discounts-reckon">
        <div class="discounts-item fl-align-center primary-text">
          <span>优惠 Special offer</span>
          <span class="price-value">-￥{{ decrTotalAmount }}</span>
        </div>
        <div class="discounts-item fl-align-center primary-text">
          <span>运费 Freight charges</span>
          <span class="price-value">-￥{{ emsAmount }}</span>
        </div>
        <div class="discounts-item fl-align-center primary-text">
          <span>应付 Cope with</span>
          <template v-if="payType == 0">
            <span class="price-value">￥{{ totalAmount }}</span>
          </template>
          <template v-if="payType == 1">
            <span class="price-value">{{ totalIntegral }}积分</span>
          </template>
          <template v-if="payType == 2">
            <span class="price-value">￥{{ totalAmount }}+{{ totalIntegral }}积分</span>
          </template>
        </div>
        <div class="discounts-item flex primary-text">
          <div>支付方式 Payment method</div>
          <el-radio-group v-model="paymentMethod" class="price-value price-radio">
            <el-radio
                v-for="item in paymentMethodOptions"
                :key="item.value"
                :label="item.value">
              <span class="radio-text">{{ item.label }}</span>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="submit-order-btn">
          <el-button type="primary" size="default" :loading="payLoading"
                     @click="toPayWay">提交订单 Submit an order
          </el-button>
        </div>
      </section>
      <SharePayDialog
          title="微信扫码完成支付 Scan the QR code to pay"
          v-if="sharePayVisible"
          :visible.sync="sharePayVisible"
          :payImg="payImg"
          @on-success="getOrderStatus"
      />
    </div>
  </div>
</template>

<script>
import GoodsPanel from "@/components/base/GoodsPanel";
import TablePage from "@/components/base/TablePage";
import SearchBar from "@/components/base/SearchBar";
import SelectAddress from "./components/SelectAddress";
import SelectCoupons from "@/components/base/SelectCoupons";
import OrderItem from "./components/OrderItem";
import SharePayDialog from "./components/SharePayDialog.vue";
import {Loading} from "element-ui";
import {orderCreditCallback} from "@/api/api";
import Login from "@/views/Login";
import {paymentMethodOptions} from "@/util/options";

function errorCallback(error) {
  console.log(JSON.stringify(error));
}

function cancelCallback() {
  console.log('Payment cancelled');
}

export default {
  name: "",
  components: {GoodsPanel, TablePage, SearchBar, SelectAddress, SelectCoupons, OrderItem, SharePayDialog},
  data() {
    return {
      payLoading: false,
      isForeign: false,//是否是外币支付
      paymentMethod: 'wechat',//支付方式
      paymentMethodOptions: this.$optionsData.paymentMethodOptions,
      contentAll: false,
      goodsData: {
        emsStoreInfoList: [],
        takeStoreInfoList: [],
      },
      goodsDataParams: {},
      takeWays: [
        {
          chName: "物流配送",
          enName: "Logistics and distribution",
          type: "emsStoreInfoList",
        },
        {
          chName: "自提",
          enName: "Self Pickup",
          type: "takeStoreInfoList",
        },
      ],
      address: {},
      addressList: [],
      decrTotalAmount: "",
      emsAmount: "",
      totalAmount: "",
      totalIntegral: "",
      showCoupon: false,
      couponList: [], //全场可使用的优惠券
      qrCode: "", //选中的通用券码
      isFirst: 1, //是否是首次进入
      orderType: 0, //0普通订单 1秒杀订单 2拼团订单 3外卖订单 4积分兑换
      payType: "", //支付类型 0金额 1积分 2积分+金额
      bonusCanUsed: "", //本次可抵扣余额
      bonusBalance: "", //奖励金余额
      moneybagRest: "",
      payImg: "", //小程序订单分享页面
      sharePayVisible: false,
      orderNo: "", //订单号
    };
  },
  async mounted() {
    const _this = this
    this.getGoodsData();
    this.getConfirmOrder(1); //获取订单信息
    this.getAddressList(); //获取收货地址
    window.checkoutOrderBack = function (type, message) {
      if (type == 'error') {
        _this.isForeign = false
        _this.$message.error(message)
      } else if (type == 'complete') {
        _this.foreignPayComplete()
      }
    }
  },
  destroyed() {
    console.log('destroyed')
  },
  methods: {
    //外币支付完成，通知服务器更新订单信息
    async foreignPayComplete() {
      const loading = this.$loading({
        lock: true,
        text: '同步订单信息',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.1)'
      })
      const orderNo = this.orderNo
      await this.$api.orderCreditCallback({orderNo})
          .then(res => {
            const apiResult = res.data?.apiResult
            console.log('apiResult===========', apiResult, res)
            if (apiResult != "SUCCESS") {
              this.$message.warning('订单数据同步失败')
            }
            this.$router.push(`/e-shop/pay-result`);
            loading.close()
          }).catch(() => {
            this.$message.warning('订单数据同步失败')
            this.$router.push(`/e-shop/pay-result`);
            loading.close()
          })

    },
    errorCallback(error) {
      console.log(JSON.stringify(error));
    },
    getGoodsData() {
      let obj = this.$route.query.obj ? JSON.parse(this.$route.query.obj) : {};
      this.goodsDataParams = obj.goodsData;
      this.orderType = obj.orderType;
    },
    //获取订单信息
    async getConfirmOrder(isFirst = 0) {
      let loadingInstance = Loading.service();
      const params = {
        ...this.goodsDataParams,
        isFirst: isFirst,
        orderType: this.orderType,
        qrCode: this.qrCode,
      };
      try {
        let {data} = await this.$api.getConfirmOrder(params);
        this.goodsData = {
          emsStoreInfoList: data.emsStoreInfoList || [],
          takeStoreInfoList: data.takeStoreInfoList || [],
        };
        this.decrTotalAmount = data.decrTotalAmount || "";
        this.emsAmount = data.emsAmount || "";
        this.totalAmount = data.totalAmount || "";
        this.totalIntegral = data.totalIntegral || "";
        this.couponList = data.couponList || [];
        this.qrCode = data.qrCode;
        this.decrCommonAmount = data.decrCommonAmount;
        this.isFirst = 0;
        this.payType = data.payType;
        this.bonusBalance = data.bonusBalance; //奖励金余额
        this.bonusCanUsed = data.bonusCanUsed; //本次可抵扣余额
        this.moneybagRest = data.moneybagRest;
        if (data.consigneeArea) {
          let [provinceName, cityName, regionName] = data.consigneeArea.split(" ");
          this.address = {
            provinceName,
            cityName,
            regionName,
            address: data.consigneeAddress,
            linkMobile: data.consigneeMobile,
            consigneeName: data.consigneeName,
            deliverId: data.deliverId,
          };
        }
      } catch (error) {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        console.log(error);
      } finally {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
      }
    },
    //获取address
    getAddress(val) {
      const {provinceName, cityName, regionName, address, linkMobile, consigneeName, id} = val;
      this.address = {
        provinceName,
        cityName,
        regionName,
        address,
        linkMobile,
        consigneeName,
        deliverId: id,
      };
    },
    //获取qrcode
    getQrcode(val) {
      this.qrCode = val;
      this.getConfirmOrder();
    },
    //获取收货地址列表
    async getAddressList() {
      const params = {
        page: 1,
        pageSize: 1000,
      };
      try {
        let {data} = await this.$api.getAddressList(params);
        console.log(data);
        this.addressList = data.list || [];
      } catch (error) {
        console.log(error);
      }
    },
    //微信支付
    async wechatPayment(orderNo, buyType) {
      try {
        if (buyType == 0) {
          await this.getAppletCode();
          // this.$router.push(`/e-shop/pay-way?orderNo=${orderNo}`);
        } else if (buyType == 1) {
          await this.$router.push(`/e-shop/pay-result?orderNo=${orderNo}`);
        }
      } catch (error) {
        console.log(error);
      }
    },
    //外币支付
    foreignPayment: async function (orderNo, totalAmount) {

      let {data} = await this.$api.getSession({
        "amount": totalAmount,
        "orderNo": orderNo
      }).catch(() => {
        this.payLoading = false
      })
      if (!data) return;
      this.isForeign = true
      Checkout.configure({
        session: {
          id: data.id
        },
        order: {
          description: 'BEIJING INTERNATIONAL HOTEL',
          id: orderNo
        },
        interaction: {
          merchant: {
            name: 'BEIJING INTERNATIONAL HOTEL',
            address: {
              line1: 'The Beijing International Hotel Convention Center',
              line2: 'Adjacent to the main hotel building'
            }
          }
        }
      });

      Checkout.showEmbeddedPage('#embed-target',
          () => {
            console.log('showLightboxFunc')
          }
      );
    },
    //支付按钮点击事件
    async toPayWay() {
      if (!Object.keys(this.address).length && this.goodsData.emsStoreInfoList.length) {
        this.$message.warning("请选择收货地址");
        return;
      }
      let {goodsData, address} = this;
      let params = {
        ...this.goodsDataParams,
        qrCode: this.qrCode,
        orderType: this.orderType,
        isBasket: this.$route.query.from == "basket" ? 1 : 0,
      };
      if (this.goodsDataParams.emsStoreInfoList.length) {
        let obj = {
          consigneeArea: address.provinceName + " " + address.cityName + " " + address.regionName,
          consigneeAddress: address.address,
          consigneeMobile: address.linkMobile,
          consigneeName: address.consigneeName,
        };
        params = {
          ...params,
          ...obj,
        };
      }
      this.payLoading = true
      const {data} = await this.$api.buyGoods(params).catch(() => {
        this.payLoading = false
      });
      //buyType 订单处理状态：0需要跳支付页 1免费无需跳支付页 2积分兑换完成
      let {orderNo, buyType, totalAmount} = data;
      this.orderNo = orderNo;
      if (this.paymentMethod == 'wechat') {
        await this.wechatPayment(orderNo, buyType)
      } else if (this.paymentMethod == 'foreign') {
        await this.foreignPayment(orderNo, totalAmount)
      }
      this.payLoading = false
    },

    //获取支付码
    async getAppletCode() {
      let {data} = await this.$api.createLink({
        content: JSON.stringify({orderNo: this.orderNo}),
      }).catch(() => {
        this.payLoading = false
      });
      const params = {
        page: `implant/orders/detail/index`,
        scene: data?.shortLink,
      };
      try {
        let {data} = await this.$api.getQrCode(params).catch(() => {
          this.payLoading = false
        });
        this.payImg = data;
        this.sharePayVisible = true;
      } catch (error) {
        console.log(error);
      }
    },
    async getOrderStatus() {
      const data = await this.getOrderCommonDetail();
      if (data.orderVO && data.orderVO.payTime) {
        await this.$router.push(`/e-shop/pay-result`);
        this.sharePayVisible = false;
      } else {
        this.$message.warning("支付未完成");
      }
    },
    async getOrderCommonDetail() {
      const params = {
        orderNo: this.orderNo,
      };
      try {
        let {data} = await this.$api.getOrderCommonDetail(params);
        return data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mar-t-60 {
  margin-top: 60px;
}

.mar-b-60 {
  margin-bottom: 60px;
}

.container-title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 20px;
}

.discounts-reckon {
  padding-top: 30px;
  border-top: 1px solid #f0f0f0;

  .discounts-item {
    justify-content: flex-end;
    margin-top: 30px;

    .price-value {
      width: 410px;
      text-align: right;
      padding-left: 20px;
      white-space: nowrap;
      margin-left: 20px;
      box-sizing: border-box;
    }
  }

  .submit-order-btn {
    text-align: right;
    margin-top: 38px;
    padding-bottom: 70px;
  }
}
.price-radio {
  text-align: left;
  border: 1px solid #DCDFE6;
  padding: 10px;
}
.radio-text {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
/deep/ .el-radio {
  display: block;
  text-align: left;
}
/deep/ .el-radio + .el-radio {
  margin-top: 10px;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  background: #E47C47 !important;
  border-color: #E47C47 !important;
}
/deep/ .el-radio.is-checked .radio-text {
  color: #E47C47 !important;
}
.flex {
  display: flex;
}
</style>
